import firebase from 'firebase/app';
import "firebase/analytics";
import 'firebase/firestore';
import Vue from 'vue'

const firebaseConfig = {
    apiKey: process.env.VUE_APP_APIKEY || "test-api-key",
    authDomain: process.env.VUE_APP_AUTHDOMAIN || "test-auth-domain",
    databaseURL: process.env.VUE_APP_DATABASEURL || "test-database-url",
    projectId: process.env.VUE_APP_PROJECTID || "test-project-id",
    storageBucket: process.env.VUE_APP_STORAGEBUCKET || "test-storage-bucket",
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID || "test-message-sender-id",
    appId: process.env.VUE_APP_APP_ID || "test-app-id",
    measurementId: process.env.VUE_APP_MEASUREMENT_ID || "test-measurement-id",
}
firebase.initializeApp(firebaseConfig)
Vue.prototype.$db = firebase.firestore()
Vue.prototype.$analytics = firebase.analytics();

